module.exports = __webpack_public_path__ + "media/images/episode-bca07ff514c735b14315c571d324dbf0.jpg";